module.exports = __webpack_public_path__ + "media/images/tooltip-4a3f355b.svg";